import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

// export const currentPresetAtom = atom(null);
export const currentModuleAtom = atomFamily((id) => atom(null));
